import React from 'react';
import Select from 'react-select';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { toast } from 'react-toastify';
import { appName, invoice_hero_plan, invoice_hero_plan_interval, acs_plan_interval, 
  mcp_plan_interval, mcheckout_plan_interval,
  acs_price, acs_trialDays,
  mcp_price, mcp_trialDays,
  mcheckout_price, mcheckout_trialDays
 } from './Constant';

class Discount extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      store: "",
      appName: appName.find(i => i.value === 'invoice_hero'),
      plan: undefined,
      formSubmitted: false,
      planList: [],
      planIntervalList: [],
      selectedPlanInterval: undefined,
      trialDays: "",
      appPrice: "",
      apiCalled: false,
      gloabalError: "",
      isLoading: true
    }
  }

  componentDidMount() {
    const cookies = new Cookies();
    if (!cookies.get("isAuthenticated")) {
      this.props.routeProps.history.push("/password");
      return;
    }

    const data = this.planRelatedDetails();

    this.setState({
      planList: data.planList,
      plan: data.planList.length > 0 ? data.planList[data.planList.length - 1] : [],
      planIntervalList: data.planIntervalList,
      selectedPlanInterval: data.planIntervalList.find(i => i.value === "monthly") ? data.planIntervalList.find(i => i.value === "monthly").value : data.planIntervalList[0],
      isLoading: false
    })
  }

  planRelatedDetails = () => {
    let planList = [];
    if (this.state.appName.value === 'invoice_hero') {
      planList = invoice_hero_plan;
    }

    let planIntervalList = [];
    if (this.state.appName.value === "invoice_hero") {
      planIntervalList = invoice_hero_plan_interval;
    } else if (this.state.appName.value === "acs") {
      planIntervalList = acs_plan_interval;
    } else if (this.state.appName.value === "mcp") {
      planIntervalList = mcp_plan_interval;
    } else if (this.state.appName.value === "mckeckout") {
      planIntervalList = mcheckout_plan_interval;
    }

    return {
      planList: planList,
      planIntervalList: planIntervalList
    }
  }

  handleTextChange = (event, nameOfTextbox) => {
    if (nameOfTextbox === 'trialDays') {
      const regex = RegExp(/(^[0-9]*$|^$)/);
      if (regex.test(event.target.value)) {
        this.setState({
          [nameOfTextbox]: event.target.value,
          gloabalError: ""
        });
      }
    } else if (nameOfTextbox === 'appPrice') {
      const regex = RegExp(/(^[0-9.\+\-]*$|^$)/);
      if (regex.test(event.target.value)) {
        this.setState({
          [nameOfTextbox]: event.target.value,
          gloabalError: ""
        });
      }
    } else {
      this.setState({
        [nameOfTextbox]: event.target.value,
        gloabalError: ""
      });
    }
  }

  handleDropDownChange = (selectedDropDownOption, nameOfDropDown) => {
    this.setState({
      [nameOfDropDown]: selectedDropDownOption,
      gloabalError: ""
    }, () => {
      if(nameOfDropDown === "appName") {
        const data = this.planRelatedDetails();
        let defaultPrice = "";
        let defaultTrialDays = "";
        if(this.state.appName.value === "acs") {
          defaultPrice = acs_price;
          defaultTrialDays = acs_trialDays;
        } else if(this.state.appName.value === "mcp") {
          defaultPrice = mcp_price;
          defaultTrialDays = mcp_trialDays;
        } else if(this.state.appName.value === "mckeckout") {
          defaultPrice = mcheckout_price;
          defaultTrialDays = mcheckout_trialDays;
        }
        this.setState({
          planList: data.planList,
          plan: data.planList.length > 0 ? data.planList[data.planList.length - 1] : [],
          planIntervalList: data.planIntervalList,
          selectedPlanInterval: data.planIntervalList.find(i => i.value === "monthly") ? data.planIntervalList.find(i => i.value === "monthly").value : data.planIntervalList[0],
          appPrice: defaultPrice,
          trialDays: defaultTrialDays
        });
      }
    })
  }

  handleCheckbox = (nameOfField) => {
    this.setState({
      [nameOfField]: !this.state[nameOfField],
      gloabalError: ""
    })
  }

  radioButtonChanged = (e) => {
    this.setState({
      selectedPlanInterval: e.currentTarget.value,
      gloabalError: ""
    })
  }

  setDiscount = () => {
    this.setState({ formSubmitted: true, apiCalled: true }, () => {
      if (this.state.store.trim().length <= 0) {
        this.setState({ apiCalled: false });
        setTimeout(() => {
          const errorMessageDiv = document.getElementsByClassName('errorMessage');
          if (errorMessageDiv && errorMessageDiv[0]) {
            errorMessageDiv[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
          }
        }, 0);
        return;
      }
      if (this.state.trialDays.trim().length > 0 || this.state.appPrice.trim().length > 0) {
        if(this.state.appName.value === "invoice_hero") {
          const data = {
            storeName: `${this.state.store}.myshopify.com`,
            planName: this.state.plan.value,
            isYearly: this.state.selectedPlanInterval === "monthly" ? false : true
          };
          if (this.state.trialDays.trim().length > 0) {
            data.trialDays = parseInt(this.state.trialDays);
          }
          if (this.state.appPrice.trim().length > 0) {
            data.price = parseFloat(this.state.appPrice);
          }
          axios.post(process.env.REACT_APP_INVOICEHRO_API_ENDPOINT + "plan/setCustomPriceForStore", data)
            .then(res => {
              this.setState({ apiCalled: false });
              this.resetAllValue();
              toast.success("Updated successfully");
            })
            .catch(err => {
              this.setState({ apiCalled: false, gloabalError: err.response && err.response.data && err.response.data.message ? err.response.data.message : "Something went wrong" });
            });
        } else if(this.state.appName.value === "acs") {
          if(this.state.trialDays.trim().length > 0 && this.state.appPrice.trim().length > 0) {
            let url = `https://www.mlveda.com/MultiCurrency/New/setDiscountedPricing?shop=${this.state.store}.myshopify.com`;
            if(this.state.trialDays.trim().length > 0) {
              url = url + `&trialDays=${this.state.trialDays.trim()}`;
            }
            if(this.state.appPrice.trim().length > 0) {
              url = url + `&price=${this.state.appPrice.trim()}`;
            }
            window.open(url, "_blank");
            this.setState({ apiCalled: false });
            this.resetAllValue();
            toast.success("Updated successfully");
          } else {
            this.setState({ apiCalled: false, gloabalError: "Please fill value in trial days and app price" });
            return;
          }
          
          // axios.get(url).then(() => {
          //     this.setState({ apiCalled: false });
          //     this.resetAllValue();
          //     toast.success("Updated successfully");
          //   })
          //   .catch(err => {
          //     this.setState({ apiCalled: false, gloabalError: err.response && err.response.data && err.response.data.message ? err.response.data.message : "Something went wrong" });
          //   });
        } else if(this.state.appName.value === "mcp") {
          if(this.state.trialDays.trim().length > 0 && this.state.appPrice.trim().length > 0) {
            let url = `https://www.mlveda.com/ShopifyApps/ShopifyMultiPricing/setDiscountedPricing?shop=${this.state.store}.myshopify.com`;
            if(this.state.trialDays.trim().length > 0) {
              url = url + `&trialDays=${this.state.trialDays.trim()}`;
            }
            if(this.state.appPrice.trim().length > 0) {
              url = url + `&price=${this.state.appPrice.trim()}`;
            }
            window.open(url, "_blank");
            this.setState({ apiCalled: false });
            this.resetAllValue();
            toast.success("Updated successfully");
          } else {
            this.setState({ apiCalled: false, gloabalError: "Please fill value in trial days and app price" });
            return;
          }
          // axios.get(url).then(() => {
          //     this.setState({ apiCalled: false });
          //     this.resetAllValue();
          //     toast.success("Updated successfully");
          //   })
          //   .catch(err => {
          //     this.setState({ apiCalled: false, gloabalError: err.response && err.response.data && err.response.data.message ? err.response.data.message : "Something went wrong" });
          //   });
        } else if(this.state.appName.value === "mckeckout") {
          if(this.state.trialDays.trim().length > 0 && this.state.appPrice.trim().length > 0) {
            let url = `https://www.mlveda.com/checkout/setDiscountedPricing?shop=${this.state.store}.myshopify.com`;
            if(this.state.trialDays.trim().length > 0) {
              url = url + `&trialDays=${this.state.trialDays.trim()}`;
            }
            if(this.state.appPrice.trim().length > 0) {
              url = url + `&price=${this.state.appPrice.trim()}`;
            }
            window.open(url, "_blank");
            this.setState({ apiCalled: false });
            this.resetAllValue();
            toast.success("Updated successfully");
          } else {
            this.setState({ apiCalled: false, gloabalError: "Please fill value in trial days and app price" });
            return;
          }
          // axios.get(url).then(() => {
          //     this.setState({ apiCalled: false });
          //     this.resetAllValue();
          //     toast.success("Updated successfully");
          //   })
          //   .catch(err => {
          //     this.setState({ apiCalled: false, gloabalError: err.response && err.response.data && err.response.data.message ? err.response.data.message : "Something went wrong" });
          //   });
        }
      } else {
        this.setState({ apiCalled: false, gloabalError: "Please fill value in trial days or app price" });
        return;
      }
    })
  }

  resetAllValue = () => {
    this.setState({
      store: "",
      appName: appName.find(i => i.value === 'invoice_hero'),
      plan: undefined,
      formSubmitted: false,
      planList: [],
      trialDays: "",
      appPrice: "",
      gloabalError: ""
    }, () => {
      const data = this.planRelatedDetails();
      this.setState({
        planList: data.planList,
        plan: data.planList.length > 0 ? data.planList[data.planList.length - 1] : [],
        planIntervalList: data.planIntervalList,
        selectedPlanInterval: data.planIntervalList.find(i => i.value === "monthly") ? data.planIntervalList.find(i => i.value === "monthly").value : data.planIntervalList[0],
        isLoading: false
      })
    })
  }

  render() {
    return (
      <div>
        {!this.state.isLoading && <div className="discount-container">
          <h1>Set discount for particular store</h1>

          <div className="custom-label">Store</div>
          <input type="text"
            className={'store ' + (this.state.formSubmitted && this.state.store.trim().length <= 0 ? 'errorInput' : '')}
            value={this.state.store}
            onChange={(e) => { this.handleTextChange(e, 'store') }} /><div className="staticStoreText">.myshopify.com</div>
          <div className="clear-fix"></div>
          {this.state.formSubmitted && this.state.store.trim().length <= 0 && <div className="errorMessage">Store name is required.</div>}

          <div className="custom-label partition-div-mt-30">App name</div>
          <Select
            isSearchable={false}
            className='custom-select-box'
            classNamePrefix='custom-select-box'
            onChange={(e) => { this.handleDropDownChange(e, 'appName') }}
            value={this.state.appName}
            options={appName} />

          {this.state.appName.value === "invoice_hero" && <div>
            <div className="custom-label partition-div-mt-30">Plan name</div>
            <Select
              isSearchable={false}
              className='custom-select-box'
              classNamePrefix='custom-select-box'
              onChange={(e) => { this.handleDropDownChange(e, 'plan') }}
              value={this.state.plan}
              options={this.state.planList} />
          </div>}

          <div className="custom-label partition-div-mt-30">Plan duration</div>
          {this.state.planIntervalList.map((interval, index) => {
            return (
              <div key={"interval-" + index} className="radioDiv">
                <input type="radio" name="interval"
                  value={interval.value}
                  checked={this.state.selectedPlanInterval === interval.value}
                  onChange={(e) => this.radioButtonChanged(e)} /><span>{interval.label}</span>
              </div>
            )
          })}

          <div className="custom-label partition-div-mt-30">Trial days</div>
          <input type="text"
            value={this.state.trialDays}
            className="store"
            onChange={(e) => { this.handleTextChange(e, 'trialDays') }} /><div className="staticStoreText">days</div>
          <div className="clear-fix"></div>

          <div className="custom-label partition-div-mt-30">App price</div>
          <input type="text"
            value={this.state.appPrice}
            className="store"
            onChange={(e) => { this.handleTextChange(e, 'appPrice') }} /><div className="staticStoreText">$/{this.state.selectedPlanInterval === 'monthly' ? "month" : "year"}</div>
          <div className="clear-fix"></div>

          {this.state.gloabalError.trim().length > 0 && <div className="errorMessage partition-div-mt-30">{this.state.gloabalError}</div>}

          <div className="save-btn-wrapper">
            <button onClick={() => { this.resetAllValue() }} className="btn-custom-secondary" >
              Reset
            </button>
            <button onClick={() => { this.setDiscount() }} disabled={this.state.apiCalled} className="btn-custom-primary" >
              Set Discount
            </button>
          </div>
        </div>}
      </div>
    )
  }
}

export default Discount;